module.exports = __webpack_public_path__ + "media/images/avatar/31-5a17be2caf617629e53d0b3d95ee4721.svg";